export default __webpack_public_path__ + "static/stick-dfb07bf4bb35126338b11e234306e894.jpg";